import { getRegisterClientInfo } from "./browserClientInfo";

const pickString = (value) => {
  if (value === undefined || value === null) return undefined;
  const trimmed = String(value).trim();
  return trimmed || undefined;
};

export function formatRegisterPhone(countryCode, phone) {
  const digits = pickString(phone)?.replace(/\D/g, "");
  if (!digits) return undefined;

  const cc = pickString(countryCode);
  if (cc) {
    const normalized = cc.startsWith("+") ? cc : `+${cc}`;
    return `${normalized}${digits}`;
  }

  return digits;
}

/** Form-only keys and aliases that must never be forwarded as register fields. */
const NON_FIELD_KEYS = new Set([
  "toc",
  "receiveOffers",
  "confirmPassword",
  "countryCode",
  "phoneFull",
  "firstName",
  "lastName",
  "dateOfBirth",
  "referredCode",
  "client",
]);

/**
 * Builds POST /api/v1/public/apps/register body from form values.
 * `client` includes auth_method, fingerprint_id, screen, device, timezone, languages, server, and browser.
 */
export async function buildRegisterPayload(formPayload = {}, defaults = {}) {
  const body = {
    client: await getRegisterClientInfo(),
  };

  const fields = {
    username: formPayload.username,
    email: formPayload.email,
    password: formPayload.password,
    phone:
      formPayload.phoneFull ||
      formatRegisterPhone(formPayload.countryCode, formPayload.phone),
    first_name: formPayload.first_name ?? formPayload.firstName,
    last_name: formPayload.last_name ?? formPayload.lastName,
    date_of_birth: formPayload.date_of_birth ?? formPayload.dateOfBirth,
    country: formPayload.country ?? defaults.country,
    currency: formPayload.currency ?? defaults.currency,
    city: formPayload.city,
    state: formPayload.state,
    referral_code: formPayload.referral_code ?? formPayload.referredCode,
  };

  Object.entries(fields).forEach(([key, value]) => {
    const normalized = pickString(value);
    if (normalized !== undefined) {
      body[key] = normalized;
    }
  });

  // Custom fields declared in registration-config are forwarded as-is; only the
  // form's own control keys and the aliases mapped above are held back.
  Object.entries(formPayload).forEach(([key, value]) => {
    if (key in fields || NON_FIELD_KEYS.has(key)) return;

    const normalized = pickString(value);
    if (normalized !== undefined) {
      body[key] = normalized;
    }
  });

  return body;
}
